import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/paan-menu/components/PaanMenuInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
